<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-certificate"></i> {{ "TITLE.SIGNATURE-PROPERTIES" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body box-style">
    <ng-container *ngIf="!haveDocumentIntegrity; then viewCertificateValue; else viewGraficSignValue">
    </ng-container>
    <ng-template #viewCertificateValue>
      <form>
        <div class="bold box-tittle-style">
          <h5 class="modal-title">{{ "TITLE.DOCUMENT-VALIDITY" | translate }}</h5>
        </div>
        <div class="mb-1 row">
          <label for="issuerCertName"
                 class="col-sm-3 col-form-label font-weight-bold cw-50">{{ "LABEL.INTEGRITY" | translate }}
            :</label>
          <div class="col-sm-4 cw-50">
            <label for="issuerCertName"
                   class="col-sm-3 col-form-label"><i style="color:#008000;font-size:25px"
                                                      class="fa fa-check-circle"></i></label>
          </div>
          <label for="issuerCertName"
                 class="col-sm-3 col-form-label font-weight-bold cw-50">{{ "LABEL.VALID-INDECOPI" | translate }}
            :</label>
          <div class="col-sm-2 cw-50">
            <label for="issuerCertName"
                   class="col-sm-3 col-form-label"><i style="color:#008000;font-size:25px"
                                                      class="fa fa-check-circle"></i></label>
          </div>
        </div>
        <div class="mb-1 row">
          <label for="issuerCertName"
                 class="col-sm-3 col-form-label font-weight-bold cw-50">{{ "LABEL.VALID-CRL" | translate }}
            :</label>
          <div class="col-sm-4 cw-50">
            <label for="issuerCertName"
                   class="col-sm-3 col-form-label"><i style="color:#008000;font-size:25px"
                                                      class="fa fa-check-circle"></i></label>
          </div>
          <label for="issuerCertName"
                 class="col-sm-3 col-form-label font-weight-bold cw-50">{{ "LABEL.SIGNATURE-COVERS-THE-ENTIRE-DOCUMENT" | translate }}
            :</label>
          <div class="col-sm-2 cw-50">
            <label for="issuerCertName"
                   class="col-sm-3 col-form-label"><i style="color:#008000;font-size:25px"
                                                      class="fa fa-check-circle"></i></label>
          </div>
        </div>
        <div class="bold box-tittle-style">
          <h5 class="modal-title">{{ "TITLE.CERTIFICATION-AUTHORITY-DATA" | translate }}</h5>
        </div>
        <br>
        <div class="mb-1 row">
          <label for="issuerCertName" class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.NAME" | translate }}
            :</label>
          <div class="col-sm-9">
            <input type="text" id="issuerCertName" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.issuerCertName}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="issuerOrganizationName"
                 class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.ORGANIZATION" | translate }}:</label>
          <div class="col-sm-9">
            <input type="text" id="issuerOrganizationName" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.issuerOrganizationName}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="issuerSerialNumber" class="col-sm-3 col-form-label font-weight-bold">Ruc:</label>
          <div class="col-sm-9">
            <input type="text" id="issuerSerialNumber" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.issuerSerialNumber}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="issuerLocalityName"
                 class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.LOCALITY" | translate }}:</label>
          <div class="col-sm-9">
            <input type="text" id="issuerLocalityName" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.issuerLocalityName}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="issuerCountry" class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.CITY" | translate }}
            :</label>
          <div class="col-sm-9">
            <input type="text" id="issuerCountry" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.issuerCountry}}">
          </div>
        </div>
<!--        <hr>-->
        <div class="user-name bold box-tittle-style">
          <h5 class="modal-title">{{ "TITLE.OPERATOR-DATA" | translate }}</h5>
        </div>
        <br>
        <div class="mb-1 row">
          <label for="operatorName" class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.NAME" | translate }}
            :</label>
          <div class="col-sm-9">
            <input type="text" id="operatorName" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.operatorName}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="operatorOrganizationName"
                 class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.ORGANIZATION" | translate }}:</label>
          <div class="col-sm-9">
            <input type="text" id="operatorOrganizationName" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.operatorOrganizationName}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="operatorSerialNumber"
                 class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.IDENTIFICATION-DOCUMENT-NUMBER" | translate }}
            :</label>
          <div class="col-sm-9">
            <input type="text" id="operatorSerialNumber" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.operatorSerialNumber}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="operatorLocalityName"
                 class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.LOCALITY" | translate }}:</label>
          <div class="col-sm-9">
            <input type="text" id="operatorLocalityName" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.operatorLocalityName}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="operatorCountry" class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.CITY" | translate }}
            :</label>
          <div class="col-sm-9">
            <input type="text" id="operatorCountry" class="form-control" [attr.disabled]="true"
                   value="{{operatorInfo.operatorCountry}}">
          </div>
        </div>
<!--        <hr>-->
        <div class="user-name bold box-tittle-style">
          <h5 class="modal-title">{{ "LABEL.VALIDITY" | translate }}</h5>
        </div>
        <br>
        <div class="mb-1 row">
          <label for="from" class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.FROM" | translate }}:</label>
          <div class="col-sm-9">
            <input type="text" id="from" class="form-control" [attr.disabled]="true" value="{{operatorInfo.from}}">
          </div>
        </div>
        <div class="mb-1 row">
          <label for="until" class="col-sm-3 col-form-label font-weight-bold">{{ "LABEL.TO" | translate }}:</label>
          <div class="col-sm-9">
            <input type="text" id="until" class="form-control" [attr.disabled]="true" value="{{operatorInfo.until}}">
          </div>
        </div>
        <br>
        <div class="d-block text-right row">
          <label for="until" class="col-form-label font-weight-bold"></label>
          <div class="col-sm-9 float-right">
            <a href="javascript:"
               (click)="downloadCertificate()"><i class="fa fa-download"></i> {{ "LINK.CLICK-HERE-TO-DOWNLOAD-CERTIFICATE" | translate }} </a>
          </div>
        </div>
      </form>
    </ng-template>
    <ng-template #viewGraficSignValue>
      <div class="bold box-tittle-style">
        <h5 class="modal-title">{{"TITLE.IMAGE-OPERATOR-SIGNER" | translate }}</h5>
      </div>
      <ngb-carousel>
        <ng-template ngbSlide>
          <label
            class="col-form-label font-weight-bold">1. {{ "LABEL.IMAGE-FRONT-OF-THE-IDENTITY-DOCUMENT" | translate }}</label>
          <img [src]="documentFrontSrc" class="d-block w-100 container-image" alt="Random first slide">
        </ng-template>
        <ng-template ngbSlide>
          <label
            class="col-form-label font-weight-bold">2. {{ "LABEL.IMAGE-BACK-OF-THE-IDENTITY-DOCUMENT" | translate }}</label>
          <img [src]="documentRearSrc" class="d-block w-100 container-image" alt="Random second slide">
        </ng-template>
        <br>
      </ngb-carousel>
    </ng-template>
  </div>
</div>
